<div class="fs-2 with-close" mat-dialog-title>
    Modifier mes notes
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <form (ngSubmit)="onYesClick()">
        <mat-form-field class="lines-3">
            <mat-label>Mes notes <i class="fa fa-info-circle" matTooltip="Notez ici toutes les informations pour suivre l’avancée de votre projet. Vos notes s’enregistrent automatiquement et vous pourrez les retrouvez à chaque visite.
Vous pouvez agrandir la taille de la zone de prise de note en tirant le coin en bas à droite"></i></mat-label>
            <textarea matInput name="comment" [(ngModel)]="comment"></textarea>
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Annuler
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">Valider</ng-container>
    </button>
</div>
